module.exports = __webpack_public_path__ + "fonts/781c3d36cf17225e356d7f7f22f1aa42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/arrow-alt-right.svg
// module id = 2028
// module chunks = 0